export enum DatalabPostMessageType {
  // Datalab 通知承接页面
  ComponentMounted = 'componentMounted', // 通知承接页面 Iframe页面已渲染完成
  ClickExplore = 'clickExplore', // 通知承接页面, 用户点击了探索按钮
  RefreshToken = 'refreshToken', // token过期后重新请求的token
  GoBackReport = 'goBackReport', // 从探索图表页面返回报表承接页面
  ClickFullscreen = 'clickFullscreen', // 点击表格放大

  // 承接页面发送过来的消息类型
  InitData = 'initData', // 页面加载完成后 首次获取token, dashboardId, 等数据
  UpdateToken = 'updateToken', // token过期后重新请求的token
  ChangeLanguage = 'changeLanguage', // 转换中英文
  ChangeTheme = 'changeTheme', // 切换主题
}

export type TDatalabCommunicatorData = {
  token: string;
  dashboardId: string;
  origin: string;
  [key: string]: any; // 允许其他可能的字段
}

export type TMessage<T = any> = {
  type: string;
  payload?: T;
}

export type TMessageHandler = (payload: any, event?: MessageEvent<any>) => void | Promise<void>;

// 基础通信器接口
export interface IBaseCommunicator {
  addMessageHandler(type: string, handler: TMessageHandler): void; // 添加通讯类型
  on(event: string, callback: Function): void; // 注册事件
  off(event: string, callback: Function): void; // 卸载事件
  emit(event: string, ...args: any[]): void; // 触发事件
  destroy(): void; // 清除
  checkTokenExpiry(token: string, minutesBeforeExpire?: number): boolean;  // 检查token有效期
  validateSendMessageOrigin(origin: string): boolean;  // 验证发送消息的来源
  configAllowedOrigins(allowedOrigins: string[]): void; //  配置允许message的来源
}

// 父页面到iframe通信器接口
export interface IParentToIframeCommunicator extends IBaseCommunicator {
  sendToIframe(type: string, payload?: unknown, targetOrigin?: string): void;
}

/**
 * 其他系统成绩页面中需要和iframe通信处理的公共业务逻辑
 * 提供父窗口与iframe之间的通信能力，包括token、dashboardId和host等数据的传递
 */
export interface IReportToDatalabCommunicator extends IParentToIframeCommunicator {
  token: string | undefined;            // 通过接口获取回来的token
  dashboardId: string | undefined;      // 当前承接页面报表的dashboard ID
  dashboardName: string | undefined;      // 当前承接页面报表的名称
  gameCode: string | undefined;      // 当前承接页面报表所在的业务
  origin: string | undefined;           // 当前承接页面报表的域名

  /**
   * 保存通信所需的数据
   * @param data 包含token、dashboardId和host等信息的通信数据
   */
  saveData(data: TDatalabCommunicatorData): void;

  /**
   * 通知iframe更新token数据
   * @param data 包含新token、dashboardId和host等信息的通信数据
   */
  updateToken(data: TDatalabCommunicatorData): void;

  /**
   * 处理iframe组件加载完成事件，发送初始化数据
   */
  initData(data: TDatalabCommunicatorData): void;
}

export type GuestTokenFetchFn = () => Promise<TDatalabCommunicatorData>;

export type TembedDatalabParams = {
  iframeSelector: string; // iframe的选择器字符串
  data: TDatalabCommunicatorData; // 其他数据
  datalabConfig?: any; // datalab的配置项
  iframeUrl?: string; // iframe的访问路径
  fetchGuestToken: GuestTokenFetchFn; // 获取token的函数
  clickExplore?: (payload: any) => void; // 点击探索按钮的回调函数
  iframeMounted?: () => void; // iframe加载完成的回调函数
  clickFullscreen?: (payload: any) => void; // 点击全屏按钮的回调函数
}

export type EmbeddedDatalab = {
  instance: IReportToDatalabCommunicator; // 通信器实例
  refreshGuestToken: Function; // 刷新token的函数
  unmount: () => void; // 卸载函数
};